import { BigNumber } from 'ethers'
import { getPoolInvestorByAddress } from './getPoolInvestorContract'
import type { Chains } from 'modules/blockChain/chains'
import type { PoolInvestor } from 'generated'
import { getERCAssetAddress } from '../constants/poolAssets'
import { UnpackedPromise } from 'shared/utils/utilTypes'
import { getPoolProjectedApy } from './getPoolProjectedApy'

export async function calcDepositPoolInfo(args: {
  chainId: Chains
  walletAddress: string
  pool: PoolInvestor
}) {
  const { chainId, walletAddress, pool } = args
  const poolAddress = pool.address
  const { asset } = getPoolInvestorByAddress(chainId, poolAddress)
  const assetAddress = getERCAssetAddress(asset, chainId)

  const [debtTokenBalance, debtTokenDecimals, apy] = await Promise.all([
    pool.balanceOf(walletAddress),
    pool.decimals(),
    getPoolProjectedApy({
      poolInvestor: pool,
      chainId,
    }),
  ])

  let deposit = BigNumber.from(0)

  if (!debtTokenBalance.isZero()) {
    deposit = await pool.getWithdrawalTokenReturnAmount(debtTokenBalance)
  }

  return {
    apy,
    deposit,
    poolAddress,
    assetAddress,
    depositedAsset: asset,
    debtTokenBalance,
    debtTokenDecimals,
  }
}

export type DepositPoolInfo = UnpackedPromise<
  ReturnType<typeof calcDepositPoolInfo>
>
